/**
 * How customers reach Yum Express support — the one place the web reads it
 * from. The backend's support address is the same (settings SUPPORT_EMAIL).
 */
export const SUPPORT_EMAIL = 'support@yum-express.com'
export const SUPPORT_PHONE = '+255 719 484 926'
export const SUPPORT_PHONE_HREF = `tel:${SUPPORT_PHONE.replace(/\s/g, '')}`
export const SUPPORT_WHATSAPP_URL = `https://wa.me/${SUPPORT_PHONE.replace(/\D/g, '')}`
